import React from "react";

import { ID } from "common/entities/IEntity";
import { ButtonView } from "common/views/button/Button.view";
import HeadingView from "common/views/heading/Heading.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { Fragment } from "core/components/FragmentProvider";
import KnowledgeBasePanelConfig from "../config/KnowledgeBasePanelConfig";
import constants from "../constants";
import { KnowledgeBase } from "./entities";

interface IKnowledgeBaseFragmentProps {
	knowledgeBase: KnowledgeBase;
	config: KnowledgeBasePanelConfig;
	currentCategory?: ID;
}

export const name: Fragment<IKnowledgeBaseFragmentProps> = {
	name: "Name",
	component: (props) => {

		return (
			<HeadingView viewKey="kb.name">
				{props.knowledgeBase.name}
			</HeadingView>
		);
	}
};

export const description: Fragment<IKnowledgeBaseFragmentProps> = {
	name: "Description",
	component: (props) => {

		return (
			<div>{props.knowledgeBase.description}</div>
		);
	}
};

export const logo: Fragment<IKnowledgeBaseFragmentProps> = {
	name: "Logo",
	component: (props) => {

		return (
			<PageLinkView viewKey="kb.link" preserveParams={false}>
				<ImageView viewKey="kb.logo" variant={ImageVariant.LOGO} src={props.knowledgeBase.iconUrl} />
			</PageLinkView>
		);
	}
};

export const categoryMenu: Fragment<IKnowledgeBaseFragmentProps> = {
	name: "Top-Level Category Menu",
	enabled: (props) => !!props.knowledgeBase.categories,
	component: (props) => (
		<div>
			{
				props.knowledgeBase.categories.map((c) => {


					return (
						<PageLinkView
							key={c.id}
							viewKey="category.root.link"
							params={{[constants.PARAM_CATEGORY_ID]: c.id}}
							preserveParams={false}
							style={{color: 'inherit'}}
							render={
								({active}) => {

									return (
										<ButtonView viewKey="category.root" span={true} isActive={active && props.currentCategory === c.id}>
											{c.name}
										</ButtonView>
									);
								}
							}
						/>
					);
				})
			}
		</div>
	)
};



// WEBPACK FOOTER //
// ./src/panels/kb/knowledgeBase/KnowledgeBaseFragments.tsx